module.exports = __webpack_public_path__ + "static/pink-floyd-logo-6342775b66f513ca2b8d7413c7ee61a9.png";